import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';
import TransactionsBox from './transactionsBox';
import AccountingEquation from './accountingEquation';

export default function AllTypes({ onComplete }) {
  const [showP, setShowP] = useState(false);
  const [showTransactionsBox, setShowTransactionsBox] = useState(false);
  const [showRight, setShowRight] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;
    
    timeouts.push(setTimeout(() => setShowP(true), currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => {
      setShowTransactionsBox(true);
      setShowRight(true);
    }, currentTime));
        
    currentTime += 8000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Balanced Equation</h1>
      
      <p className={getAnimationClass(showP)}>
        In this level, you'll be making multiple decisions, including deciding on the specific accounts impacted. 
      </p>

      {showTransactionsBox && (
        <div className={`transition-transactions-financial-statements no-stretch ${getAnimationClass(true)}`}>
          <TransactionsBox />
          <div className={`transition-transactions-financial-statement-formula-container ${getAnimationClass(showRight)}`}>
            <p><b>Level 3:</b> Decide accounts impacted and other decisions</p>
            <AccountingEquation firstSign="equals" secondSign="plus" />
            <p><b className="red">Pro Tip:</b> Every transaction <b>affects at least two accounts</b>, keeping the equation balanced.</p>
          </div>
        </div>
      )}
    </>
  );
}